export default __webpack_public_path__ + "static/media/BusinessTillAccount.844b916c.png";